import styled from 'styled-components';
import { Media } from '../../../theme/Media';
import Textarea from '../Textarea';
export const Wrapper = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media ${Media.xsMax} {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;
export const StyledTextarea = styled(Textarea) `
  && {
    margin-top: 0;
  }

  @media ${Media.smMin} {
    height: ${({ height }) => `${height}px`};
  }

  @media ${Media.xsMax} {
    min-height: ${({ height }) => `${height}px`};
  }
`;
export const SearchWrapper = styled.div `
  display: flex;
  gap: 4px;
  margin-bottom: 8px;

  & > :first-child {
    flex-grow: 1;
  }
`;
